import { render, staticRenderFns } from "./SquareComissionModal.vue?vue&type=template&id=4e5c9b63"
import script from "./SquareComissionModal.vue?vue&type=script&lang=js"
export * from "./SquareComissionModal.vue?vue&type=script&lang=js"
import style0 from "./SquareComissionModal.vue?vue&type=style&index=0&id=4e5c9b63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports